import React from 'react'

import styled from 'styled-components'

interface SortIcon {
  sortDirection?: string | null;
}

const SortIcon = ({ sortDirection = null }: SortIcon) => {
  if (sortDirection === 'asc') {
    return <S.Icon className="icon-sort-up" role="img" aria-label="sort ascending" />
  } else if (sortDirection === 'desc') {
    return <S.Icon className="icon-sort-down" role="img" aria-label="sort descending" />
  } else {
    return (
      <div aria-label="sort this column">
        <S.Icon className="icon-sort-up" />
        <S.Icon className="icon-sort-down" />
      </div>
    )
  }
}

export default SortIcon

const S = {
  Icon: styled.span`
    position: absolute;
    margin-right: 10px;
    right: 0px;
    top: 15px;
    font-size: 20px;
  `
}
